import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var typography = function typography(style) {
  return function (_ref) {
    var theme = _ref.theme;

    if (theme) {
      var currentTheme = theme.armor || theme;

      if (currentTheme.typography) {
        var variant = currentTheme.typography[style];

        if (variant) {
          return _objectSpread(_objectSpread({}, variant), {}, {
            fontFamily: "".concat(variant.fontFamily, ",sans-serif"),
            fontSize: currentTheme.typography.pixelToRem(variant.fontSize),
            lineHeight: currentTheme.typography.pixelToRem(variant.lineHeight)
          });
        }
      }
    }

    return style;
  };
};